import React from 'react';
import {IoReorderFourSharp} from 'react-icons/io5';

export function OtherIcon({...rest}) {
  return <IoReorderFourSharp size={35} {...rest} />;
}



// WEBPACK FOOTER //
// ./src/tickets/icons/other.js